import React, { Component } from "react";
import { connect } from "react-redux";
import cx from 'classnames';
import { Link, withRouter } from "react-router-dom";
import {
  Modal,
  Card,
  CardHeader,
  IconButton,
  Typography,
  CardContent,
  TextField,
  Grid,
  FormGroup,
  FormControlLabel,
  Radio,
  CardActions,
  Button,
  WithStyles,
  withStyles,
  Checkbox,
} from "@material-ui/core";
import {
  getClientsWithoutPagination,
  getRolesListWithoutPagination,
  addRole,
  switchSelectedTab,
  setRolesTab,
} from "../actions/userActions";

import { MyPATTextField, MyPATDialog } from "../../common";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import CloseIcon from "@material-ui/icons/Close";
import { userStyles } from "../styles";
import ACLService from "../../acl/services/aclService";
import Autocomplete from "../common/Autocomplete";
import { permissionArray } from "../types/RolesPermission";
import DialogHeader from "../common/DialogHeader";
import DialogFooter from "../common/DialogFooter";
import { Error } from "@material-ui/icons";
import AccessDenied from "../../common/AccessDenied";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import _, {capitalize} from "lodash";
import { convertCamelCaseToText } from '../../../utils';
import { PERMISSION_CONTENT_TYPES, PERMISSION_QUESTION_CONTENT_TYPES, PERMISSION_TEST_CONTENT_TYPES, COMMON_CHECKBOXES, CONTENT_SECTION_KEYS, CONTENT_SECTION_TYPES, MODULES, MODULE_TO_BUCKET_MAP, TEST_ADDITIONAL_MODULES, USER_RIGHTS, UTILS, titleCase, EDP_REPORTS_STRING_CONSTANT, ADDITION_DRAFT_MODULE, USER_RIGHTS_CONTENT_LABEL } from "../../../constants/comman";

interface AddRoleDialogProps extends WithStyles<typeof userStyles> {
  isDialogOpen: boolean;
  getClientsWithoutPagination: any;
  getRolesListWithoutPagination: any;
  addRole: any;
  dialogCloseHandler: () => void;
  clientsList: any;
  roleAddedSuccessfully: boolean;
  reportingToList: any;
  match: any;
  history: any;
  location: any;
  formErrors: any;
  switchSelectedTab: any;
  setRolesTab: any;
  loggedInUserData: any;
}
interface AddRoleDialogState {
  formData: any;
  userDetails: any;
  formErrors: any;
  isFormValid: any;
  clientsName: any;
  rolePayload: any;
  moduleAccess: any;
  isAdmin: any;
  isSuperAdmin: any;
  showDropdown: boolean;
  wrapperRef: any;
  openResetPopup: boolean;
  accessDenied: boolean;
  selectedSection: string;
  openSectionDialog: boolean;
  temporaryPermissionData: any;
  disableSave: boolean;
}
class AddRoleDialog extends Component<AddRoleDialogProps, AddRoleDialogState> {
  constructor(props: AddRoleDialogProps) {
    super();
    this.state = {
      formData: {
        clientName: "",
        role: "",
        roleDescription: "",
        reportingTo: "",
        permissions: JSON.parse(JSON.stringify(permissionArray)),
      },
      userDetails: {},
      formErrors: {
        name: "",
        role: "",
        roleDescription: "",
        reportingTo: "",
      },
      isFormValid: false,
      clientsName: [],
      rolePayload: {
        role: {
          name: "",
          description: "",
          reportingTo: "",
          permissions: JSON.parse(JSON.stringify(permissionArray)),
        },
        client: {
          id: "",
        },
      },
      moduleAccess: [],
      isAdmin: false,
      isSuperAdmin: false,
      showDropdown: false,
      wrapperRef: null,
      openResetPopup: false,
      accessDenied: false,
      selectedSection: '',
      openSectionDialog: false,
      temporaryPermissionData: [],
      disableSave: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  validateForm(errors: any) {
    let validPer = true;
    let valid = true;
    let validData = true;
    validPer = this.checkForPermissions();
    Object.values(errors).forEach(
      (val: any) => val.length > 0 && (valid = false)
    );
    if (
      this.state.rolePayload.role.name &&
      this.state.rolePayload.role.description &&
      this.state.rolePayload.role.reportingTo &&
      this.state.rolePayload.client.id
    ) {
      validData = true;
    } else {
      validData = false;
    }
    return valid && validData && validPer;
  }
  renderCustomDropdown() {
    const { classes, reportingToList } = this.props;
    const { showDropdown } = this.state;
    return(
    <Grid className={classes.customDropdown}>
    <span
      className={[
        classes.variationSelect,
        this.state.formData.clientName === ""
          ? classes.disable
          : " ",
      ].join(" ")}
      onClick={this.handleDropdown}
    >
      <span className="selectBox">
        {this.state.formData.reportingTo
          ? this.state.formData.reportingTo
          : "Select Role"}
      </span>
      <span className={classes.arrowIcon}>
        <img src="/assets/svg/userManagement/arrowUP.svg" />
      </span>
    </span>
    {showDropdown && (
      <>
        <Grid className={classes.dropdownList}>
          <Grid>
            {reportingToList &&
              reportingToList.length !== 0 &&
              reportingToList.map((role: any) => {
                return (
                  <>
                    <Grid
                      item
                      className={classes.listItem}
                      onClick={(e) => {
                        this.setReportingTo(role.role);
                      }}
                    >
                      {role.role}
                    </Grid>
                  </>
                );
              })}
          </Grid>
        </Grid>
      </>
    )}
  </Grid>)
  }
  handleChange(event: any) {
    // event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.formErrors;
    let updatedRole = this.state.rolePayload.role;
    let updatedFormData = this.state.formData;

    switch (name) {
      case "role":
        errors.role =
          value.length < 3 ? "Please enter at least 3 characters" : "";
        updatedRole.name = value;
        updatedFormData.role = value;
        this.setState((prevState: any) => ({
          formData: updatedFormData,
          rolePayload: {
            ...prevState.rolePayload,
            role: updatedRole,
          },
        }));
        break;
      case "roleDescription":
        errors.roleDescription =
          value.length < 5 ? "Please enter at least 5 characters" : "";
        updatedRole.description = value;
        updatedFormData.roleDescription = value;
        this.setState((prevState: any) => ({
          formData: updatedFormData,
          rolePayload: {
            ...prevState.rolePayload,
            role: updatedRole,
          },
        }));
        break;
      default:
        break;
    }
    const formValid = this.validateForm(errors);
    this.setState({
      formErrors: errors,
      isFormValid: formValid,
    });
  }
  handleClosePopup() {
    let updatedRole = this.state.rolePayload.role;
    updatedRole.permissions = this.state.temporaryPermissionData;
    this.setState((prevState: any) => ({
      openResetPopup: false,
      openSectionDialog: false,
      formData: {
        ...prevState.formData,
        permissions: this.state.temporaryPermissionData
      },
      rolePayload: {
        ...prevState.rolePayload,
        role: updatedRole,
      },
    }))
  }
  handleSave() {
    this.setState((prevState: any) => ({
      openSectionDialog: false,
      temporaryPermissionData: this.state.formData.permissions
    }))
  }
  resetForm = () => {
    this.setState((prevState: any) => ({
      formData: {
        clientName: this.state.isAdmin ? prevState.formData.clientName : "",
        role: "",
        roleDescription: "",
        reportingTo: "",
        permissions: JSON.parse(JSON.stringify(permissionArray)),
      },
      formErrors: {
        name: "",
        role: "",
        roleDescription: "",
        reportingTo: "",
      },
      rolePayload: {
        role: {
          name: "",
          description: "",
          reportingTo: "",
          permissions: JSON.parse(JSON.stringify(permissionArray)),
        },
        client: {
          id: this.state.isAdmin ? prevState.rolePayload.client.id : "",
        },
      },
      isFormValid: false,
      openResetPopup: false
    }));
  };

  checkForPermissions() {
    let valid = true;
    this.state.rolePayload.role.permissions.forEach((ele: any) => {
      if (ele.access.length < 1) {
        valid = false;
      }
    });
    return valid;
  }
  handleSubmit = (event: any) => {
    event.preventDefault();
    let permissionsArray = this.state.rolePayload.role.permissions;
    permissionsArray = permissionsArray.map((ele: any) => {
      if(ele.module === "goal" || ele.module === "user" || ele.module === "course") {
        if((ele.access.includes("edit") || ele.access.includes("create")) && (!ele.access.includes("view"))) {
          ele.access.push("view");
        }
      }
      return ele;
    })
    this.setState((prevState: any) => ({
      rolePayload: {
        ...prevState.rolePayload,
        role: {
          ...prevState.rolePayload.role,
          permissions: permissionsArray
        }
      }
    }), () => {
      if (this.validateForm(this.state.formErrors)) {
        this.props.addRole(this.state.rolePayload);
      }
    });

  };

  componentDidMount() {
    this.props.getClientsWithoutPagination();
    const userD: any = ACLService.getUserDetailsFromStorage();
    this.setState({
      userDetails: userD,
      isAdmin:
        userD && userD.authenticatedUser && userD.authenticatedUser.isAdmin,
      isSuperAdmin:
        userD &&
        userD.authenticatedUser &&
        userD.authenticatedUser.isSuperAdmin,
    });
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.userDetails !== this.state.userDetails) {
      let { userDetails } = this.state;
      if (this.state.isAdmin) {
        let errors = this.state.formErrors;

        errors.name = "";
        this.setState((prevState: any) => ({
          formData: {
            ...prevState.formData,
            clientName: userDetails.authenticatedUser.clients.length === 1 ? userDetails.authenticatedUser.clientId.name : '',
          },
          rolePayload: {
            ...prevState.rolePayload,
            client: {
              id: userDetails.authenticatedUser.clients.length === 1 ? userDetails.authenticatedUser.clientId._id: '',
            },
          },
          moduleAccess: userDetails.authenticatedUser.clientId
            .access,
          formErrors: errors,
        }));
        if( userDetails.authenticatedUser.clients.length === 1) {
        this.props.getRolesListWithoutPagination(
          userDetails.authenticatedUser.clientId._id
        );
        } else {
          let clientsName =
         _.get(userDetails, 'authenticatedUser.clients', []).map((ele: any) => ele.name);
        this.setState({
          clientsName: clientsName,
        });
        }
      }
      if ((!this.state.isAdmin && !this.state.isSuperAdmin)) {
        this.setState({
          accessDenied: true
        })

      }
    }
    if (prevProps.clientsList !== this.props.clientsList && this.state.isSuperAdmin) {
      let clientsName =
        this.props.clientsList &&
        this.props.clientsList.clients &&
        this.props.clientsList.clients.map((ele: any) => ele.name);
          this.setState({
            clientsName: clientsName,
          });
      }
    if (prevProps.roleAddedSuccessfully !== this.props.roleAddedSuccessfully) {
      this.props.history.push("/userManagement");
      this.props.switchSelectedTab("Roles");
      this.props.setRolesTab(true);
    }
    if (prevProps.formErrors !== this.props.formErrors) {
      this.setState(
        {
          formErrors: this.props.formErrors,
        },
        () => {
          this.validateForm(this.state.formErrors);
        }
      );
    }
  }

  checkDisableCondition(module: any, key: any) {
    let perArray = [MODULES.GOAL, MODULES.USER, MODULES.EDP];
    perArray = [...perArray, ...PERMISSION_QUESTION_CONTENT_TYPES, ...PERMISSION_TEST_CONTENT_TYPES, PERMISSION_CONTENT_TYPES.DEFAULT_TEST_TEMPLATE, PERMISSION_CONTENT_TYPES.CUSTOM_TEST_TEMPLATE, PERMISSION_CONTENT_TYPES.STUDY_MATERIAL];
    if (perArray.includes(module)) {
      if (key === "none") {
        const data =
          this.state.formData &&
          this.state.formData.permissions &&
          this.state.formData.permissions.filter(function(val: any) {
            if (val.module === module) {
              return val;
            }
          });
        if (
          (data &&
            data !== [] &&
            data.length > 0 &&
            data[0] &&
            data[0].access &&
            data[0].access.includes("none")) ||
          ( data && data[0] && data[0].access && data[0].access.length === 0)
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        const data =
          this.state.formData &&
          this.state.formData.permissions &&
          this.state.formData.permissions.filter(function(val: any) {
            if (val.module === module) {
              return val;
            }
          });
        if (
          !(
            data &&
            data !== [] &&
            data.length > 0 &&
            data[0] &&
            data[0].access &&
            data[0].access.includes("none")
          )
        ) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return false;
    }
  }
  openSectionDialog(module: string) {
    this.setState((prevState) => ({
      selectedSection: module,
      openSectionDialog: true,
      temporaryPermissionData: prevState.formData.permissions
    }));
  }

  getSectionCount(module: string){
    return UTILS.ADDITIONAL_SETTINGS;
    // now displaying additional setting instead of count
    /* let data = this.state.formData.permissions.filter(function(val: any) {
       return (val.module === module)
      })
    let section = _.get(data, '[0].sections', []).length
    if((module === 'question' && section === 11) ||
    (module === 'test' && section === 4) ||
    (module === 'studyMaterial' && section === 3) ) {
     return 'All Sections'
    } else if(section > 1){
      return `${section} Sections`
    } else {
      return `${section} Section`
    } */
   
  }
  checkEditPermission(module: string) {
    const data = this.state.formData.permissions.filter(function(val: any) {
      if (val.module === module) {
        return val;
      }
    });
    return data && data[0] && data[0].access.includes(USER_RIGHTS.EDIT) || data[0].access.includes(USER_RIGHTS.EDIT_CLIENT_WISE);
  }
  checkCreatePermission(module: string) {
    const permission = this.state.formData.permissions.find((value: any) => value.module === module);
    return permission && permission.access.includes(USER_RIGHTS.CREATE);
  }
  renderPermissionCheckbox(
    label: any,
    module: any,
    key?: any,
    disableClick?: any
  ) {
    const { classes } = this.props;
    return (
      <FormControlLabel
        className={[classes.customRadio, classes.marginZero].join(" ")}
        control={
          <Checkbox
            disabled={this.checkDisableCondition(module, key)}
            checked={
              this.state.formData.permissions.filter(function(val: any) {
                if (val.module === module) {
                  return val.access.includes(key);
                }
              }).length
            }
            classes={{
              root: classes.checkbox,
              checked: classes.checkedCheckbox,
              colorPrimary: classes.primaryColor,
            }}
            onChange={() =>
              this.changePermission(event, module, key, disableClick)
            }
            color="primary"
            disableRipple
          />
        }
        label={label}
        classes={{ label: [classes.fontSize_SM, classes.grey].join(" ") }}
      />
    );
  }
  changeAccess(event: any, module: any, key?: any, disableClick?: boolean) {
    if (disableClick) return;
    let disableSave = false;
    let updatedPermissions = JSON.parse(
      JSON.stringify(this.state.formData.permissions)
    );
    // check if module exists
    const data = updatedPermissions.filter(function (val: any) {
      if (val.module === module) {
        return val; 
      }
    });
    var foundIndex = updatedPermissions.findIndex(
      (item: any) => item.module === module
    );
    // if module exist
    if (data && data.length > 0) {
      let sectionData: any = JSON.parse(
        JSON.stringify(this.state.formData.permissions[foundIndex])
      );
      if (event.target.checked) { // if checkbox is checked
        let newSection = {
          module: key,
          access: [
            "edit"
          ]
        }
        sectionData.sections.push(newSection)
        updatedPermissions[foundIndex] = sectionData;
      } else {  // if checkbox is unchecked
        let index = sectionData.sections.findIndex(
          (item: any) => item.module === key
        );
        sectionData.sections.splice(index, 1);
        if (sectionData.sections.length === 0) {
          disableSave = true;
        }
        updatedPermissions[foundIndex] = sectionData;
      }
    }
    let updatedRole = this.state.rolePayload.role;
    updatedRole.permissions = updatedPermissions;
    let formValid = this.validateForm(this.state.formErrors);

    this.setState((prevState: any) => ({
      formData: {
        ...prevState.formData,
        permissions: updatedPermissions,
      },
      rolePayload: {
        ...prevState.rolePayload,
        role: updatedRole,
      },
      isFormValid: formValid,
      disableSave
    }));
  }
  checkPermissionExist( module: any, key: any){
  let data = this.state.formData.permissions.filter(function(val: any) {
  if (val.module === module) {
    let sections = val.sections && val.sections.filter(function(sectionData: any) { 
     if(sectionData.module === key) {
      return sectionData
     }
    })
          return sections && sections.length > 0
  }
  }).length > 0
  return data
}
renderAccessCheckbox(
  label: any,
  module: any,
  key?: any,
  disableClick?: boolean
  ) {
  const { classes } = this.props;
  return (
    <FormControlLabel
    className={[classes.customRadio, classes.marginTB10].join(" ")}
    control={
      <Checkbox
      checked={this.checkPermissionExist(module, key)
      }
      classes={{
        root: classes.checkbox,
        checked: classes.checkedCheckbox,
        colorPrimary: classes.primaryColor,
        }}
      onChange={() =>
        this.changeAccess(event, module, key, disableClick)
      }
      color="primary"
      disableRipple
      />
    }
    label={label}
    classes={{ label: [classes.fontSize_SM, classes.grey].join(" ") }}
    />
  );
  }
  handleDropdown = () => {
    if(this.state.formData.clientName !== "") {
    let errors = this.state.formErrors;
    errors.reportingTo =
      this.state.formData.reportingTo.length === 0
        ? "This field is required"
        : "";

    this.setState({
      showDropdown: !this.state.showDropdown,
      formErrors: errors,
    });
  }
  };
  handleDropdownClose = () => {
    this.setState({
      showDropdown: false,
    });
  };  
  changePermission(event: any, module: any, key?: any, disableClick?: any) {
    if (!disableClick) {
      let updatedPermissions = this.state.formData.permissions;
      const data = this.state.formData.permissions.filter(function(val: any) {
        if (val.module === module) {
          return val;
        }
      });
      var foundIndex = this.state.formData.permissions.findIndex(
        (item: any) => item.module === module
      );
      if (event.target.checked) {
        if (!data[0]) {
          let moduleObj;
          if(module === 'share') {
            moduleObj = {
              module: "share",
              access: ["allow"],
            };
          } else {
            moduleObj = {
              module: module,
              access: [key],
            };
          }
          updatedPermissions.push(moduleObj);
        } else {
          data[0].access.push(key);
          if ([MODULES.EDP_QUESTION_ISSUE_REPORT, MODULES.EDP_QUESTION_CREATE_REPORT].includes(module)) {
            data[0].access = [key];
          }
          // Permission management for question, test and study material
          if ([...PERMISSION_QUESTION_CONTENT_TYPES, ...PERMISSION_TEST_CONTENT_TYPES, PERMISSION_CONTENT_TYPES.STUDY_MATERIAL].includes(module)
          ) {
            if ([USER_RIGHTS.EDIT, USER_RIGHTS.EDIT_CLIENT_WISE].includes(key) && !data[0].access.includes(USER_RIGHTS.VIEW)) {
              data[0].access.push(USER_RIGHTS.VIEW);
            }
          }
          // Permission management for goal, user and course
          if (module === MODULES.GOAL || module === MODULES.USER) {
            if (key === "edit" && !data[0].access.includes("create")) {
              data[0].access.push("create");
            }
          }
          if (module === "tag") {
            if (key === "edit" && !data[0].access.includes("createOptional")) {
              data[0].access.push("createOptional");
            }
            if (key === "edit" && !data[0].access.includes("createMandatory")) {
              data[0].access.push("createMandatory");
            }
          }
          // Permission management for edp
          if (module === MODULES.EDP) {
            if (key === USER_RIGHTS.DOWNLOAD && !data[0].access.includes(USER_RIGHTS.VIEW)) {
              data[0].access.push(USER_RIGHTS.VIEW);
            }
          }
          if (PERMISSION_QUESTION_CONTENT_TYPES.includes(module)) {
            if ([USER_RIGHTS.EDIT, USER_RIGHTS.EDIT_CLIENT_WISE].includes(key) && !(data[0].sections || []).length) {
              data[0].sections = [];
              let sections = ['content', 'options', 'answer', 'idealTime', 'syllabus', 'hints', 'solution', 'difficulty',
            'relevantExams', 'benchmarking', 'tags']
            sections.forEach((ele: any) => {
             let element =  {
              module: ele,
              access: [
                "edit"
              ]
              }
              data[0].sections.push(element);
            })
            }
          }
          if (PERMISSION_TEST_CONTENT_TYPES.includes(module)) {
            if ((key === USER_RIGHTS.EDIT || key === USER_RIGHTS.EDIT_CLIENT_WISE) && !(data[0].sections || []).length) {
              data[0].sections = data[0].sections || [];
              let sections = ['basicDetails', 'syllabus', 'format', 'questions']
            sections.forEach((ele: any) => {
             let element =  {
              module: ele,
              access: [
                "edit"
              ]
              }
              data[0].sections.push(element);
            })
            }
            if (key === USER_RIGHTS.CREATE) {
              data[0].sections = data[0].sections || [];
              const sharedSection = {
                module: MODULE_TO_BUCKET_MAP[module],
                access: [USER_RIGHTS.EDIT]
              }
              data[0].sections.push(sharedSection);
            }
          }
          if (module === "studyMaterial") {
            if ([USER_RIGHTS.EDIT, USER_RIGHTS.EDIT_CLIENT_WISE].includes(key) && !(data[0].sections || []).length) {
              data[0].sections = []
              let sections = ['notes', 'tags', 'syllabus']
            sections.forEach((ele: any) => {
             let element =  {
              module: ele,
              access: [
                "edit"
              ]
              }
              data[0].sections.push(element);
            })
            }
          }
          if (module === MODULES.COURSE) {
            data[0].access = (data[0].access || []).filter((permission: string) => permission !== USER_RIGHTS.NONE);
          }
          updatedPermissions[foundIndex] = data[0];
        }
      } else {
        if (data[0].module === "share") {
          updatedPermissions.splice(foundIndex, 1);
        } else {
          let keyIndex = this.state.formData.permissions[
            foundIndex
          ].access.indexOf(key);
          // Permission management for question, test and study material
          if (
            PERMISSION_QUESTION_CONTENT_TYPES.includes(module) ||
            module === "studyMaterial"
          ) {
            if (key === "create" && !data[0].access.includes("edit")) {
              data[0].access.splice(keyIndex, 1);
            } else if (key !== "create") {
              data[0].access.splice(keyIndex, 1);
              if ([USER_RIGHTS.EDIT, USER_RIGHTS.EDIT_CLIENT_WISE].includes(key) && [USER_RIGHTS.EDIT, USER_RIGHTS.EDIT_CLIENT_WISE].every(right => !data[0].access.includes(right)) ) {
                delete data[0].sections
              }
            }
          }
          if (PERMISSION_TEST_CONTENT_TYPES.includes(module)) {
            if (key === USER_RIGHTS.VIEW) {
              if (!data[0].access.includes(USER_RIGHTS.EDIT)) {
                data[0].access.splice(keyIndex, 1);
              }
            } else {
              data[0].access.splice(keyIndex, 1);
              if ([USER_RIGHTS.EDIT, USER_RIGHTS.EDIT_CLIENT_WISE].includes(key) && [USER_RIGHTS.EDIT, USER_RIGHTS.EDIT_CLIENT_WISE].every(right => !data[0].access.includes(right))) {
                data[0].sections = (data[0].sections || []).filter((section: any) => Object.values(CONTENT_SECTION_KEYS).includes(section.module));
                if (!data[0].sections.length) delete data[0].sections;
              }
              if (key === USER_RIGHTS.CREATE) {
                data[0].sections = (data[0].sections || []).filter((section: any) => !Object.values(CONTENT_SECTION_KEYS).includes(section.module));
                if (!data[0].sections.length) delete data[0].sections;
              }
            }
          }
          // Permission management for goal, user and course
          if (module === "goal" || module === "user" || module === "course") {
            if (key === "create" && !data[0].access.includes("edit")) {
              data[0].access.splice(keyIndex, 1);
            } else if (key !== USER_RIGHTS.CREATE || MODULES.COURSE === module) {
              data[0].access.splice(keyIndex, 1);
            }
          }
          // Permission management for edp
          if (module === "edp") {
            if (key === "view" && !data[0].access.includes("download")) {
              data[0].access.splice(keyIndex, 1);
            } else if (key !== "view")  {
              data[0].access.splice(keyIndex, 1);
            }
          }
          // Permission management for tag
           if(module === "tag") {
            if (key === "createOptional" && data[0].access.includes("edit")) {
              data[0].access.splice(keyIndex, 1);
            } else if (key === "edit" && !data[0].access.includes("createOptional"))  {
              data[0].access.splice(keyIndex, 1);
              data[0].access.push("createOptional")
            } else if (key !== "createOptional" ) {
              data[0].access.splice(keyIndex, 1);
            }
           }
          if ([PERMISSION_CONTENT_TYPES.TEMPLATE_SETTINGS, PERMISSION_CONTENT_TYPES.CUSTOM_TEST_TEMPLATE, PERMISSION_CONTENT_TYPES.DEFAULT_TEST_TEMPLATE].includes(module)) {
            data[0].access.splice(keyIndex, 1);
          }
          if ((!(data[0].access || []).length) && module === MODULES.COURSE) {
            data[0].access.push(USER_RIGHTS.NONE);
          }
          updatedPermissions[foundIndex] = data[0];
        }
      }
      let updatedRole = this.state.rolePayload.role;
      updatedRole.permissions = updatedPermissions;
      let formValid = this.validateForm(this.state.formErrors);
      this.setState((prevState: any) => ({
        formData: {
          ...prevState.formData,
          permissions: updatedPermissions,
        },
        rolePayload: {
          ...prevState.rolePayload,
          role: updatedRole,
        },
        isFormValid: formValid,
      }));
    }
  }
  setReportingTo(value: any) {
    let errors = this.state.formErrors;
    let formValid: any;
    errors.reportingTo = value.length === 0 ? "This field is required" : "";
    const selectedReportingTo =
      this.props.reportingToList &&
      this.props.reportingToList.filter(function(role: any) {
        return role.role === value;
      });
    if (selectedReportingTo && selectedReportingTo.length) {
      let updatedRole = this.state.rolePayload.role;
      updatedRole.reportingTo = selectedReportingTo[0]._id;
      this.setState(
        (prevState: any) => ({
          rolePayload: {
            ...prevState.rolePayload,
            role: updatedRole,
          },
        }),
        () => {
          formValid = this.validateForm(errors);
          this.setState((prevState: any) => ({
            isFormValid: formValid,
          }));
        }
      );
    }
    this.setState((prevState: any) => ({
      formData: {
        ...prevState.formData,
        reportingTo: value,
      },
      formErrors: errors,
      showDropdown: false,
    }));
  }
  moduleAccessData(role: any, access?: any) {
    let accessArray = access ? access : this.state.moduleAccess;
    return (
      accessArray &&
      accessArray.filter(function(ele: any) {
        return ele.name === role;
      }) &&
      accessArray.filter(function(ele: any) {
        return ele.name === role;
      })[0] &&
      accessArray.filter(function(ele: any) {
        return ele.name === role;
      })[0].isAllowed
    );
  }
  removePermissionsFromPayload(access?: any) {
    let rolesData = this.state.rolePayload.role;
    let perArray = ["goal", "user", "edp", "course"];
    perArray.forEach((ele: any) => {
      let foundIndex = rolesData.permissions.findIndex(
        (item: any) => item.module === ele
      );
      let goalData = this.moduleAccessData(ele, access);
      if (!goalData) {
        rolesData.permissions.splice(foundIndex, 1);
      }
    });
    this.setState((prevState: any) => ({
      formData: {
        ...prevState.formData,
        permissions: rolesData.permissions,
      },
      rolePayload: {
        ...prevState.rolePayload,
        role: rolesData,
      },
    }));
  }
  setWrapperRef(node: any) {
    this.setState({
      wrapperRef: node,
    });
  }
  handleClickOutside(event: any) {
    if (
      this.state.wrapperRef &&
      !this.state.wrapperRef.contains(event.target)
    ) {
      this.setState({
        showDropdown: false,
      });
    }
  }
  onAutoCompleteChange(value: any) {
    let errors = this.state.formErrors;
    errors.name = value.length === 0 ? "This field is required" : "";
    let updatedFormData = this.state.formData;
    updatedFormData.clientName = value;
    if (value.length === 0) {
      updatedFormData.reportingTo = "";
    }
    updatedFormData.permissions = JSON.parse(JSON.stringify(permissionArray));
    let clList = this.state.isSuperAdmin ? this.props.clientsList.clients : this.state.userDetails.authenticatedUser.clients;
    const selectedClientId = clList.filter(function(
      client: any
    ) {
      return client.name.trim() === value;
    });
    if (selectedClientId.length) {
      let updatedRole = this.state.rolePayload.role;
      this.props.getRolesListWithoutPagination(selectedClientId[0]._id || selectedClientId[0].id);
      updatedRole.permissions = JSON.parse(JSON.stringify(permissionArray));
      let client = {
        id: selectedClientId[0]._id || selectedClientId[0].id,
      };
      this.setState(
        (prevState: any) => ({
          formData: {
            ...prevState.formData,
            permissions: JSON.parse(JSON.stringify(permissionArray)),
          },
          rolePayload: {
            client: client,
            role: updatedRole,
          },
          moduleAccess: selectedClientId[0].access,
        }),
        () => {
          this.removePermissionsFromPayload(selectedClientId[0].access);
        }
      );
    }
    this.setState({
      formData: updatedFormData,
      formErrors: errors,
    });
  }
  renderPermissonPara() {
    const { classes } = this.props;
    return (
      <>
        <Grid>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid>
              <Typography className={classes.subTxt}>
                User can give the following rights to a role:
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justify="center"
            className={classes.placeholderBorderModal}
          >
            <span>Content Permissions</span>
            <Typography className={classes.textHeading}>
              User can provide the following permissions for each content
              created in Glorifire Authors Library.
            </Typography>
            <Typography className={classes.permissionContent}>
              <ul>
                <li>
                  <span>View :</span> It allows user to view content created by
                  his peers. This is a default permission given to every user
                </li>
                <li>
                  <span>Create :</span> It allows user to create content. User
                  can edit his/her own content as well.
                </li>
                <li>
                  <span>Validate :</span> It allows user to give feedback over a
                  particular content which will be forwarded to user for review
                </li>
                <li>
                  <span>Edit :</span> It permits user to edit the
                  content/tags/templates created by others
                </li>
                <li>
                  <span>Share:</span> It allows user to share content amongst
                  different organization.
                </li>
                <li>
                  <span>Assign Test:</span> The user can only assign test to
                  batches in his centre only when he is permitted through this
                  option
                </li>
                <li>
                  <span>Create Optional:</span> It gives the permission to
                  create tags which will be optional to everybody .This is the
                  default right given to every user.
                </li>
                <li>
                  <span>Create Mandatory :</span> User can give permissions to a
                  role for creating mandatory tags through this option
                </li>
              </ul>
            </Typography>
          </Grid>

          <Grid className={classes.placeholderBorderModal}>
            <span>Other Permissions</span>
            <Typography className={classes.textHeading}>
              User can provide the following permissions for other module apart
              from my library:
            </Typography>
            <Typography className={classes.permissionContent}>
              <ul>
                <li>
                  <span>None :</span> This permission does not allow user to
                  access the module{" "}
                </li>
                <li>
                  <span>Create :</span> This permission allows user to create
                  goal/course/ add user respectively
                </li>
                <li>
                  <span>Edit :</span> This permissions gives rights to edit the
                  goal/course/ users details created by the user and his/her
                  peers
                </li>
                <li>
                  <span>View:</span> User can view the reports of an EDP but
                  cannot download it.
                </li>
                <li>
                  <span>Download:</span> Through this permission, user will be
                  able to download the EDP report
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }

  renderEdpReportSection(title: string, module: string, rights: Array<any>) {
    const { classes } = this.props
    return (
      <Grid item xs={6}>
        <FormGroup>
          <Typography
            gutterBottom
            className={cx(
              classes.fontSize_MD,
              classes.fontWeight_SM,
              classes.black,
            )}
          >
            {title}
          </Typography>
          <FormGroup>
            {rights.map((right: string) => (
              this.renderPermissionCheckbox(
                titleCase(right),
                module,
                right
              )
            ))}
          </FormGroup>
        </FormGroup>
      </Grid>
    );
  }

  renderEdpReports() {
    const { classes } = this.props;
    return (
      <Grid container spacing={8} alignItems="center" className={classes.paddingTopSM}>
        {this.renderEdpReportSection(
          EDP_REPORTS_STRING_CONSTANT.QUESTION_CREATION_REPORT,
          MODULES.EDP_QUESTION_CREATE_REPORT,
          [USER_RIGHTS.NONE, USER_RIGHTS.DOWNLOAD],
        )}
        {this.renderEdpReportSection(
          EDP_REPORTS_STRING_CONSTANT.QUESTION_ISSUES_REPORT,
          MODULES.EDP_QUESTION_ISSUE_REPORT,
          [USER_RIGHTS.NONE, USER_RIGHTS.DOWNLOAD],
        )}
      </Grid>
    );
  };

  render() {
    
    const { classes, reportingToList, dialogCloseHandler } = this.props;
    const { showDropdown, userDetails, selectedSection } = this.state;
    return (
      <>
      { this.state.accessDenied && ( 
          <>
       <AccessDenied 
        imageURL="/assets/svg/access-denied.svg"
        heading="Access Denied!"
        subPara="You don’t have access to this content. You can request for the access from your supervisor."
       /> 
        </>
      )}  
      { !this.state.accessDenied && (  
           <>  
        <Modal
          BackdropProps={{ invisible: true }}
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          hideBackdrop={true}
          className={[
            classes.fontSizeLG,
            classes.fontWeight500,
            classes.modal,
          ].join(" ")}
          open={true}
        >
          <div className={classes.paper}>
            <Card elevation={0}>
              <DialogHeader
                urlName="/userManagement"
                selectedTab="Roles"
                iconNode={
                  <IconButton
                    aria-label="settings"
                    onClick={dialogCloseHandler}
                  >
                    <CloseIcon className={classes.fontSizeLG} />
                  </IconButton>
                }
                headerTitle="Add New Role"
              />
              <CardContent className={classes.cardContentStyle}>
                <Grid>
                  <Card
                    className={[classes.CustomCard, classes.overflowAuto].join(
                      " "
                    )}
                  >
                    <Grid container spacing={8}>
                      <Grid item xs={6}>
                        <Grid
                          className={[
                            classes.roleFormElement,
                            classes.customInputBox,
                          ].join(" ")}
                        >
                          <Typography
                            variant="body1"
                            gutterBottom
                            className={[
                              classes.fontSize_SM,
                              classes.black,
                            ].join(" ")}
                          >
                            Select Client/Org.
                          </Typography>
                          <Grid className={classes.autoCompleteBox}>
                            {this.state.isAdmin && _.get(userDetails, 'authenticatedUser.clients', []).length === 1 && (
                              <input
                                type="text"
                                name="name"
                                className={classes.customDisabled}
                                placeholder="Enter Client Name."
                                value={this.state.formData.clientName}
                                disabled
                              />
                            )}
                            {(_.get(userDetails, 'authenticatedUser.clients', []).length > 1 || this.state.isSuperAdmin) &&
                              this.state.clientsName && (
                                <Autocomplete
                                  options={this.state.clientsName}
                                  onChange={this.onAutoCompleteChange.bind(
                                    this
                                  )}
                                  valueAutoComp={this.state.formData.clientName}
                                  isMulti={false}
                                  placeholderText='Search and Select Client'
                                />
                              )}
                          </Grid>
                          {_.get(userDetails, 'authenticatedUser.clients', []).length > 1 &&
                            this.state.formErrors.name.length > 0 && (
                              <Typography className={classes.errorText}>
                                <Error /> {this.state.formErrors.name}
                              </Typography>
                            )}
                        </Grid>
                      </Grid>

                      <Grid item xs={6}>
                        <Grid
                          className={[
                            classes.roleFormElement,
                            classes.customInputBox,
                          ].join(" ")}
                        >
                          <Typography
                            variant="body1"
                            gutterBottom
                            className={[
                              classes.fontSize_SM,
                              classes.black,
                            ].join(" ")}
                          >
                            Role
                          </Typography>
                          <Grid>
                            <input
                              type="text"
                              name="role"
                              className={`${
                                this.state.formErrors.role.length > 0
                                  ? classes.errorBorder
                                  : "myPatTextField"
                              }`}
                              onChange={this.handleChange}
                              placeholder="Enter Role Name"
                              value={this.state.formData.role || ""}
                            />
                          </Grid>
                          {this.state.formErrors.role.length > 0 && (
                            <Typography className={classes.errorText}>
                              <Error /> {this.state.formErrors.role}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>

                      <Grid item xs={6}>
                        <Grid
                          className={[
                            classes.roleFormElement,
                            classes.customInputBox,
                          ].join(" ")}
                        >
                          <Typography
                            variant="body1"
                            gutterBottom
                            className={[
                              classes.fontSize_SM,
                              classes.black,
                            ].join(" ")}
                          >
                            Role Description
                          </Typography>
                          <textarea
                            placeholder="Enter Description"
                            name="roleDescription"
                            value={this.state.formData.roleDescription || ""}
                            onChange={this.handleChange}
                            className={`${classes.customInputElement} ${
                              this.state.formErrors.roleDescription.length > 0
                                ? classes.errorBorder
                                : classes.customInputElement
                            }`}
                          />
                          {this.state.formErrors.roleDescription.length > 0 && (
                            <Typography className={classes.errorText}>
                              <Error />
                              {this.state.formErrors.roleDescription}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>

                      <Grid item xs={6}>
                        <Grid
                          className={[
                            classes.roleFormElement,
                            classes.customInputBox,
                          ].join(" ")}
                        >
                          <Typography
                            variant="body1"
                            gutterBottom
                            className={[
                              classes.fontSize_SM,
                              classes.black,
                            ].join(" ")}
                          >
                            Reporting To
                          </Typography>
                          { showDropdown && (
                        <ClickAwayListener
                        onClickAway={this.handleDropdownClose}> 
                          {this.renderCustomDropdown()}
                        </ClickAwayListener>
                        )}
                        { !showDropdown && (
                          this.renderCustomDropdown()
                        )}
                          {this.state.formErrors.reportingTo.length > 0 && (
                            <Typography className={classes.errorText}>
                              <Error /> {this.state.formErrors.reportingTo}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>

                  <Grid>
                    <Typography className={classes.CardTitle}>
                      Permission
                      <span className={classes.iconStyle}>
                        <CustomInfoIcon
                          isInfoIcon={true}
                          isCenterArrow={true}
                          isRightArrow={false}
                          knowMoreAbout={false}
                          dialogTitle="Permission"
                          dialogPara="Permissions define the level of access to each feature that will be given to a user of the given role. This helps to to control the amount of data that can be seen/ manipulated by a user for any particular feature"
                          imageURL="/assets/svg/myLibrary/permissionIcon.svg"
                          htmlElement=''
                          toolTipDirection="top"
                          details="Click to know more"
                        />
                      </span>
                    </Typography>
                  </Grid>
                  <Card className={classes.CustomCard}>
                    <Grid className={classes.placeholderBorder}>
                      <span className={classes.positionSet}>My Library<span className={classes.error}>*</span>
                        <span className={classes.iconStyle}>
                        <CustomInfoIcon
                          isInfoIcon={true}
                          isCenterArrow={true}
                          isRightArrow={false}
                          knowMoreAbout={false}
                          dialogTitle="MyLibrary"
                          dialogPara=""
                          imageURL="/assets/svg/infoIcon/my-library.svg"
                          htmlElement={
                            <>
                            <h4>
                            User can provide the following permissions for each content created in Glorifire Authors Library.</h4>
                            <Grid container className={classes.marginBottomMD}>
                              <Grid item xs={3}><strong>View</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={8}>It allows a user to view the content created by other users of the same Organization. This permission is provided by default to each user for every feature</Grid>
                              
                              <Grid item xs={3}><strong>Create</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={8}>It allows a user to create content of the given type. Users with this permission can also edit self-created content</Grid>
                              
                              <Grid item xs={3}><strong>Validate</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={8}>It allows the user to give feedback on the content forwarded to him/her for review</Grid>

                              <Grid item xs={3}><strong>Edit</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={8}>It permits the user to edit the content created by other users of the same Organization. In case of tags and templates, the Edit functionality works globally, 
                              i.e. users can edit the tags/ templates created by any user</Grid>
                              
                              <Grid item xs={3}><strong>Create Optional</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={8}>It allows the user to create optional tags (visible to all users). This is the default permission given to every user</Grid>
                              
                              <Grid item xs={3}><strong>Create Mandatory</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={8}>It allows the user to create mandatory tags, which will be visible and mandatory to all users</Grid>
                            </Grid>
                            </>
                          }
                          toolTipDirection="top"
                          details="Click to know more"
                        />
                      </span>
                      </span>
                      <h6 
                      className={[
                        classes.roleSubheading,
                        classes.marginTopSet,
                        ].join(" ")}
                        >
                          1. Study Material Settings
                          </h6>
                      <Grid container spacing={8} alignItems="center">
                        <Grid item xs={3}>
                          <Typography
                            className={[
                              classes.fontSize_SM,
                              classes.fontWeight_MD,
                              classes.grey,
                            ].join(" ")}
                          >
                            Study Material :
                          </Typography>
                        </Grid>
                        <Grid item xs={9}>
                          <Grid container spacing={8} alignItems="center">
                            <FormGroup row className={classes.paddingTopSM}>
                              {this.renderPermissionCheckbox(
                                capitalize(USER_RIGHTS.NONE),
                                PERMISSION_CONTENT_TYPES.STUDY_MATERIAL,
                                USER_RIGHTS.NONE,
                              )}
                              {this.renderPermissionCheckbox(
                                "View",
                                "studyMaterial",
                                "view",
                              )}
                              {this.renderPermissionCheckbox(
                                "Create",
                                "studyMaterial",
                                "create"
                              )}
                              {this.renderPermissionCheckbox(
                                "Validate",
                                "studyMaterial",
                                "validate"
                              )}
                              {this.renderPermissionCheckbox(
                                USER_RIGHTS_CONTENT_LABEL[USER_RIGHTS.EDIT],
                                "studyMaterial",
                                "edit"
                              )}
                              {this.renderPermissionCheckbox(
                                USER_RIGHTS_CONTENT_LABEL[USER_RIGHTS.EDIT_CLIENT_WISE],
                                MODULES.STUDYMATERIAL,
                                USER_RIGHTS.EDIT_CLIENT_WISE
                              )}
                            </FormGroup>
                            {this.checkEditPermission('studyMaterial') && 
                              <span className={classes.allSections} onClick={() => this.openSectionDialog('studyMaterial')}>{this.getSectionCount('studyMaterial')}</span>}
                          </Grid>
                        </Grid>
                      </Grid>
                      <h6 className={classes.roleSubheading}>2. Question Settings</h6>
                      {MODULES.QUESTION_MODULES.map(questionModule => 
                      (<Grid container spacing={8} alignItems="center">
                        <Grid item xs={3}>
                          <Typography
                            className={[
                              classes.fontSize_SM,
                              classes.fontWeight_MD,
                              classes.grey,
                            ].join(" ")}
                          >
                            {questionModule.DISPLAY_NAME} :
                          </Typography>
                        </Grid>
                        <Grid item xs={9}>
                          <Grid container spacing={8} alignItems="center">
                            <FormGroup row className={classes.paddingTopSM}>
                              {COMMON_CHECKBOXES.map(checkbox => this.renderPermissionCheckbox(
                                USER_RIGHTS_CONTENT_LABEL[checkbox] || titleCase(checkbox),
                                questionModule.NAME,
                                checkbox,
                              ))}
                            </FormGroup>
                            {this.checkEditPermission(questionModule.NAME) && 

                            <span className={classes.allSections} onClick={() => this.openSectionDialog(questionModule.NAME)}>{this.getSectionCount(questionModule.NAME)}</span>
                              }
                          </Grid>
                        </Grid>
                      </Grid>)
                      )}

                      <h6 className={classes.roleSubheading}>3. Test Settings</h6>
                      {MODULES.TEST_MODULES.map(testModule => 
                      (<Grid container spacing={8} alignItems="center">
                        <Grid item xs={3}>
                          <Typography
                            className={[
                              classes.fontSize_SM,
                              classes.fontWeight_MD,
                              classes.grey,
                            ].join(" ")}
                          >
                            {testModule.DISPLAY_NAME} :
                          </Typography>
                        </Grid>
                        <Grid item xs={9}>
                          <Grid container spacing={8} alignItems="center">
                            <FormGroup row className={classes.paddingTopSM}>
                              {COMMON_CHECKBOXES.map(checkbox => this.renderPermissionCheckbox(
                                USER_RIGHTS_CONTENT_LABEL[checkbox] || capitalize(checkbox),
                                testModule.NAME,
                                checkbox,
                              ))}
                            </FormGroup>
                            {(this.checkEditPermission(testModule.NAME) || this.checkCreatePermission(testModule.NAME)) && 

                            <span className={classes.allSections} onClick={() => this.openSectionDialog(testModule.NAME)}>{this.getSectionCount(testModule.NAME)}</span>
                              }
                          </Grid>
                        </Grid>
                      </Grid>)
                      )}

                      <h6 className={classes.roleSubheading}>4. Test Template Settings</h6>
                      { MODULES.TEMPLATE_MODULES.map(templateModule => 
                        (<Grid container spacing={8} alignItems="center">
                          <Grid item xs={3}>
                            <Typography
                              className={[
                                classes.fontSize_SM,
                                classes.fontWeight_MD,
                                classes.grey,
                              ].join(" ")}
                            >
                              {templateModule.DISPLAY_NAME} :
                            </Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <Grid container spacing={8} alignItems="center">
                              <FormGroup row 
                              className={[
                                classes.paddingTopSM, 
                                classes.widthSetFour,
                                ].join(" ")}
                                >
                              {COMMON_CHECKBOXES.filter(checkbox => ![USER_RIGHTS.VALIDATE, USER_RIGHTS.EDIT_CLIENT_WISE].includes(checkbox)).map(checkbox => this.renderPermissionCheckbox(
                              capitalize(checkbox),
                              templateModule.NAME,
                              checkbox,
                            ))}
                              </FormGroup>
                            </Grid>
                          </Grid>
                        </Grid>)
                      )}

                      <Grid container spacing={8} alignItems="center">
                        <Grid item xs={3}>
                          <Typography
                            className={[
                              classes.fontSize_SM,
                              classes.fontWeight_MD,
                              classes.grey,
                            ].join(" ")}
                          >
                            Tag Settings :
                          </Typography>
                        </Grid>
                        <Grid item xs={9}>
                          <Grid container spacing={8} alignItems="center">
                            <FormGroup row 
                            className={[
                              classes.paddingTopSM, 
                              classes.widthSetThree,
                            ].join(" ")}
                              >
                              {this.renderPermissionCheckbox(
                                "Create Optional",
                                "tag",
                                "createOptional"
                              )}
                              {this.renderPermissionCheckbox(
                                "Create Mandatory",
                                "tag",
                                "createMandatory"
                              )}
                              {this.renderPermissionCheckbox(
                                "Edit",
                                "tag",
                                "edit"
                              )}
                            </FormGroup>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container spacing={8}>
                      {(this.state.formData.clientName === "" ||
                        this.moduleAccessData("goal")) && (
                        <Grid item xs={6}>
                          <Grid>
                            <Typography
                              className={[
                                classes.fontSize_LG,
                                classes.fontWeight_MD,
                                classes.grey,
                              ].join(" ")}
                            >
                              Goal Management
                              <span className={classes.error}>*</span>
                              <span className={classes.iconStyle}>
                        <CustomInfoIcon
                          isInfoIcon={true}
                          isCenterArrow={true}
                          isRightArrow={false}
                          knowMoreAbout={false}
                          dialogTitle="Goal Management"
                          dialogPara=""
                          imageURL="/assets/svg/infoIcon/goal-management.svg"
                          htmlElement={
                            <>
                            <h4>
User can provide the following permissions for the Goal Management module:</h4>
                            <Grid container className={classes.marginBottomMD}>
                              <Grid item xs={2}><strong>None</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This does not allow the user to access this module</Grid>
                              
                              <Grid item xs={2}><strong>Create</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This allows the user to create a goal</Grid>
                              
                              <Grid item xs={2}><strong>Edit</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This allows the user to edit goals created by anyone in the Organization</Grid>
                            </Grid>
                            </>
                          }
                          toolTipDirection="top"
                          details="Click to know more"
                        />
                      </span>
                            </Typography>
                          </Grid>
                          <Grid>
                            <Grid container alignItems="center">
                              <FormGroup row className={classes.paddingTopSM}>
                                {this.renderPermissionCheckbox(
                                  "None",
                                  "goal",
                                  "none"
                                )}
                                {this.renderPermissionCheckbox(
                                  "Create",
                                  "goal",
                                  "create"
                                )}
                                {this.renderPermissionCheckbox(
                                  "Edit",
                                  "goal",
                                  "edit"
                                )}
                              </FormGroup>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {(this.moduleAccessData("edp") ||
                        this.state.formData.clientName === "") && (
                        <Grid item xs={6}>
                          <Grid>
                            <Typography
                              className={[
                                classes.fontSize_LG,
                                classes.fontWeight_MD,
                                classes.grey,
                              ].join(" ")}
                            >
                              EDP Reports
                              <span className={classes.error}>*</span>
                              <span className={classes.iconStyle}>
                        <CustomInfoIcon
                          isInfoIcon={true}
                          isCenterArrow={true}
                          isRightArrow={false}
                          knowMoreAbout={false}
                          dialogTitle="EDP Reports"
                          dialogPara=""
                          imageURL="/assets/svg/infoIcon/edp-report.svg"
                          htmlElement={
                            <>
                            <h4>User can provide the following permissions for the EDP Reports module:</h4>
                            <Grid container className={classes.marginBottomMD}>
                              <Grid item xs={2}><strong>None</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This does not allow the user to access this module</Grid>
                              
                              <Grid item xs={2}><strong>View</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This allows the user to only view (and not download) the reports of an EDP (within the Organization)</Grid>

                              <Grid item xs={2}><strong>Download</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This allows the user to view &#38; download the reports of an EDP (within the Organization)</Grid>
                            </Grid>
                            </>
                          }
                          toolTipDirection="top"
                          details="Click to know more"
                        />
                      </span>
                            </Typography>
                          </Grid>
                              {this.renderEdpReports()}
                        </Grid>
                      )}
                                        
                      {(this.state.formData.clientName === "" ||
                        this.moduleAccessData("user")) && (
                        <Grid item xs={6}>
                          <Grid className={classes.marginTopMD}>
                            <Typography
                              className={[
                                classes.fontSize_LG,
                                classes.fontWeight_MD,
                                classes.grey,
                              ].join(" ")}
                            >
                              User Management
                              <span className={classes.error}>*</span>
                              <span className={classes.iconStyle}>
                        <CustomInfoIcon
                          isInfoIcon={true}
                          isCenterArrow={true}
                          isRightArrow={false}
                          knowMoreAbout={false}
                          dialogTitle="User Management"
                          dialogPara=""
                          imageURL="/assets/svg/infoIcon/user-management.svg"
                          htmlElement={
                            <>
                            <h4>User can provide the following permissions for the User Management module:</h4>
                            <Grid container className={classes.marginBottomMD}>
                              <Grid item xs={2}><strong>None</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This does not allow the user to access this module</Grid>
                              
                              <Grid item xs={2}><strong>Create</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This permission allows the user to add a new user in the organization</Grid>
                              
                              <Grid item xs={2}><strong>Edit</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This permission allows the user to edit the details of other users in the Organization</Grid>
                            </Grid>
                            </>
                          }
                          toolTipDirection="top"
                          details="Click to know more"
                        />
                      </span>
                            </Typography>
                          </Grid>
                          <Grid>
                            <Grid container alignItems="center">
                              <FormGroup row className={classes.paddingTopSM}>
                                {this.renderPermissionCheckbox(
                                  "None",
                                  "user",
                                  "none"
                                )}
                                {this.renderPermissionCheckbox(
                                  "Create",
                                  "user",
                                  "create"
                                )}
                                {this.renderPermissionCheckbox(
                                  "Edit",
                                  "user",
                                  "edit"
                                )}
                              </FormGroup>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {(this.state.formData.clientName === "" ||
                        this.moduleAccessData("course")) && (
                        <Grid item xs={6}>
                          <Grid className={classes.marginTopMD}>
                            <Typography
                              className={[
                                classes.fontSize_LG,
                                classes.fontWeight_MD,
                                classes.grey,
                              ].join(" ")}
                            >
                              Course Management
                              <span className={classes.error}>*</span>
                              <span className={classes.iconStyle}>
                        <CustomInfoIcon
                          isInfoIcon={true}
                          isCenterArrow={true}
                          isRightArrow={false}
                          knowMoreAbout={false}
                          dialogTitle="Course Management"
                          dialogPara=""
                          imageURL="/assets/svg/infoIcon/course-management.svg"
                          htmlElement={
                            <>
                            <h4>User can provide the following permissions for the Course Management module:</h4>
                            <Grid container className={classes.marginBottomMD}>
                              <Grid item xs={2}><strong>None</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This does not allow the user to access this module</Grid>
                              
                              <Grid item xs={2}><strong>Create</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This allows the user to create a course</Grid>
                              
                              <Grid item xs={2}><strong>Edit</strong></Grid>
                              <Grid item xs={1}>:</Grid>
                              <Grid item xs={9}>This allows the user to edit courses created by anyone in the Organization</Grid>
                            </Grid>
                            </>
                          }
                          toolTipDirection="top"
                          details="Click to know more"
                        />
                      </span>
                            </Typography>
                          </Grid>
                          <Grid>
                            <Grid container alignItems="center">
                              <FormGroup row className={classes.paddingTopSM}>
                              {this.renderPermissionCheckbox(
                                      convertCamelCaseToText(USER_RIGHTS.VIEW),
                                      MODULES.COURSE,
                                      USER_RIGHTS.VIEW
                                    )}
                                {this.renderPermissionCheckbox(
                                  "Create",
                                  "course",
                                  "create"
                                )}
                                {this.renderPermissionCheckbox(
                                  "Edit",
                                  "course",
                                  "edit"
                                )}
                                  {this.renderPermissionCheckbox(
                                    convertCamelCaseToText(USER_RIGHTS.PUBLISH),
                                    MODULES.COURSE,
                                    USER_RIGHTS.PUBLISH
                                  )}
                              </FormGroup>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                    <Grid item xs={6}>
                      <Grid className={classes.marginTopMD}>
                        <Typography
                          className={[
                            classes.fontSize_LG,
                            classes.fontWeight_MD,
                            classes.grey,
                          ].join(" ")}
                        >
                          Share Content (Inter Organization)
                          <span className={classes.iconStyle}>
                        <CustomInfoIcon
                          isInfoIcon={true}
                          isCenterArrow={true}
                          isRightArrow={false}
                          knowMoreAbout={false}
                          dialogTitle="Share Content"
                          dialogPara="Enabling this permission will allow the user to share content with users of other Organizations"
                          imageURL="/assets/svg/infoIcon/share.svg"
                          htmlElement=''
                          toolTipDirection="top"
                          details="Click to know more"
                        />
                      </span>
                        </Typography>
                      </Grid>
                      <Grid container spacing={8} alignItems="center">
                        <FormGroup row className={classes.paddingTopSM}>
                          {this.renderPermissionCheckbox(
                            "Allow",
                            "share",
                            "allow"
                          )}
                        </FormGroup>
                      </Grid>
                    </Grid>
                    
                    </Grid>




                  </Card>
                  <MyPATDialog
                  dialogOpen={this.state.openResetPopup}
                  dialogHasActions={true}
                  dialogHeading={<Typography className={classes.resetHeading}>Reset Confirmation</Typography>}
                  isAlignCenter={true}
                  customButtonVariant="withoutBorderCloseIcon"
                  isCustomBackground={false}
                  onDialogClose={this.handleClosePopup.bind(this)}
                  isborderDialogAction={true}
                  customDialogActions={
                    <>
                      <Grid
                        container
                        justify="flex-end"
                        alignItems="flex-end"
                      >
                        <Button className={[classes.resetButton, classes.resetButtonEdit].join(' ')} 
                        onClick={this.handleClosePopup.bind(this)}
                        color="primary">No</Button>
                        <Button variant="contained"
                        onClick={this.resetForm.bind(this)}
                        color="primary">Yes</Button>
                      </Grid>
                    </>
                  }
                >
                  <Grid container className={classes.restDialogCotent}>
                  <Typography align="center">
                    Upon clicking reset, all the values will disappear. <br />
                    Are you sure, you want to reset all the values ?
                  </Typography>
                  </Grid>

                </MyPATDialog>
                {/* Select Editable selection Dialog */}
                      <MyPATDialog
                        dialogOpen={this.state.openSectionDialog}
                        dialogHeading={
                          <>
                            <Typography className={classes.dialogCustomHeading}>Additional Settings</Typography>
                          </>
                        }
                        isAlignCenter={false}
                        variantHeader="leftHeader"
                        customButtonVariant="withoutBorderCloseIcon"
                        isCustomBackground={false}
                        otherDialogProps={{
                          fullWidth: true,
                          maxWidth: 'sm',
                        }}
                        onDialogClose={this.handleClosePopup.bind(this)}
                        customDialogActions={
                          <>
                            <Button color="primary" onClick={this.handleClosePopup.bind(this)}>
                              Cancel
                            </Button>
                            <Button variant="contained" color="primary" disabled={this.state.disableSave}
                             onClick={this.handleSave.bind(this)}>Save</Button>
                          </>
                        }
                      >{PERMISSION_QUESTION_CONTENT_TYPES.includes(this.state.selectedSection) && 
                        <Grid container justify="flex-start">
                          <Typography className={[classes.fontSize_LG,
                            classes.fontWeight_MD,
                            classes.grey,
                            classes.marginBot20,
                            ].join(' ')}
                            >Select Editable Sections for Question</Typography>
                          <Grid item xs={12}>
                            <Grid container justify="flex-start">
                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Question Content",
                                  selectedSection,
                                  "content"
                                )}
                              </Grid>

                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Options",
                                  selectedSection,
                                  "options"
                                )}
                              </Grid>

                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Answer",
                                  selectedSection,
                                  "answer"
                                )}
                              </Grid>
                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Ideal Time",
                                  selectedSection,
                                  "idealTime"
                                )}
                              </Grid>

                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Syllabus",
                                  selectedSection,
                                  "syllabus"
                                )}
                              </Grid>

                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Hints",
                                  selectedSection,
                                  "hints"
                                )}
                              </Grid>

                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Solution",
                                  selectedSection,
                                  "solution"
                                )}
                              </Grid>
                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Difficulty/ Skill",
                                selectedSection,
                                  "difficulty"
                                )}
                              </Grid>
                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Relevant Exams",
                                selectedSection,
                                  "relevantExams"
                                )}
                              </Grid>
                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Benchmarking",
                                  selectedSection,
                                  "benchmarking"
                                )}
                              </Grid>
                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Extra Tags",
                                  selectedSection,
                                  "tags"
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          {this.checkEditPermission(selectedSection) &&
                            <>
                              <Typography className={classes.contentType}>Select Test Status To Edit</Typography>
                              <Grid item xs={12}>
                                {this.renderAccessCheckbox(
                                  ADDITION_DRAFT_MODULE.DISPLAY_NAME,
                                  selectedSection,
                                  ADDITION_DRAFT_MODULE.KEY
                                )}
                              </Grid>
                            </>
                          }
                        </Grid>}
                        {PERMISSION_TEST_CONTENT_TYPES.includes(this.state.selectedSection) && 
                        <Grid container justify="flex-start">
                          {this.checkCreatePermission(selectedSection) && (
                            <>
                              <Typography className={classes.contentType}>Select Sections For Questions Accessibility For Test Creation</Typography>
                              <Grid item xs={12}>
                                <Grid container justify="flex-start">
                                  {CONTENT_SECTION_TYPES.map(section =>
                                  (<Grid item xs={4}>
                                    {this.renderAccessCheckbox(
                                      section.title,
                                      selectedSection,
                                      section.value,
                                      section.value === MODULE_TO_BUCKET_MAP[selectedSection]
                                    )}
                                  </Grid>)
                                  )}
                                </Grid>
                              </Grid>
                            </>
                          )}
                          {this.checkEditPermission(selectedSection) && (
                            <>
                              <Typography className={classes.contentType}>Select Editable Sections for Test</Typography>
                                <Grid item xs={12}>
                                  <Grid container justify="flex-start">
                                    {TEST_ADDITIONAL_MODULES.map(module =>
                                    (<Grid item xs={4}>
                                      {this.renderAccessCheckbox(
                                        module.DISPLAY_NAME,
                                        selectedSection,
                                        module.KEY
                                      )}
                                    </Grid>)
                                    )}
                                  </Grid>
                                </Grid>
                            </>
                          )}
                          {this.checkEditPermission(selectedSection) &&
                            <>
                              <Typography className={classes.contentType}>Select Test Status To Edit</Typography>
                              <Grid item xs={12}>
                                {this.renderAccessCheckbox(
                                  ADDITION_DRAFT_MODULE.DISPLAY_NAME,
                                  selectedSection,
                                  ADDITION_DRAFT_MODULE.KEY
                                )}
                              </Grid>
                            </>
                          }
                        </Grid>
                        }
                        {this.state.selectedSection === 'studyMaterial' && 
                        <Grid container justify="flex-start">
                          <Typography className={classes.contentType}>Content type - Study Material</Typography>
                          <Grid item xs={12}>
                            <Grid container justify="flex-start">
                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Notes/Video Content",
                                  "studyMaterial",
                                  "notes"
                                )}
                              </Grid>
                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Syllabus",
                                  "studyMaterial",
                                  "syllabus"
                                )}
                              </Grid>
                              <Grid item xs={4}>
                                {this.renderAccessCheckbox(
                                  "Extra Tags",
                                  "studyMaterial",
                                  "tags"
                                )}
                              </Grid>

                            </Grid>
                          </Grid>
                          {this.checkEditPermission(selectedSection) &&
                            <>
                              <Typography className={classes.contentType}>Select Test Status To Edit</Typography>
                              <Grid item xs={12}>
                                {this.renderAccessCheckbox(
                                  ADDITION_DRAFT_MODULE.DISPLAY_NAME,
                                  selectedSection,
                                  ADDITION_DRAFT_MODULE.KEY
                                )}
                              </Grid>
                            </>
                          }
                        </Grid> }
                      </MyPATDialog>
                {/* End */}
                </Grid>
              </CardContent>
              <DialogFooter
                htmlElements={
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.resetButton}
                      onClick={() => {
                        this.setState({
                          openResetPopup: true
                        })
                      }}                
                    >
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.btnCreateGoal}
                      disabled={!this.state.isFormValid}
                      onClick={this.handleSubmit}
                    >
                      Add Role
                    </Button>
                  </>
                }
              />
            </Card>
          </div>
        </Modal>
        </>
       )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  clientsList: state.clientManagement.rolesManagement.clientsList,
  reportingToList: state.clientManagement.rolesManagement.reportingTo.roleData,
  roleAddedSuccessfully:
    state.clientManagement.rolesManagement.roleAddedSuccessfully,
  formErrors: state.clientManagement.rolesManagement.formErrors,
  loggedInUserData:
    state.loginData.userData &&
    state.loginData.userData.loggedInUserData
});

const mapDispatchToProps = {
  getClientsWithoutPagination,
  getRolesListWithoutPagination,
  addRole,
  switchSelectedTab,
  setRolesTab,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(withRouter(AddRoleDialog)));
